<template>
  <div>
    <transition name="slide-up">
      <div class="modal" v-if="modal">
        <div class="xbtn">
          <button @click="close">
            <img src="@/assets/imgs/close_x.png" alt="" />
          </button>
        </div>

        <div class="title">
          <h1>
            <img
              src="@/assets/imgs/newbridge_logo.png"
              alt=""
              style="width: 152px"
            />
          </h1>
          <h2>
            다음 세대와 이전 세대의 <br />
            새로운 연결다리, 뉴브릿지
          </h2>
        </div>

        <div class="desc">
          <p>
            뉴브릿지 스튜디오(Newbridge Studio)는 <br />
            기독교 안의 새로운 일하는 방식을 <br />
            지닌 연결다리입니다.<br />
            <br />
            우리는 하나님과 세상, 기술과 사람,<br />
            이전 세대와 다음 세대를<br />
            연결하기 위한 일들을 만들어 갑니다.<br />
            <br />
            이번 ‘크리스천 은사찾기’ 프로젝트를 통해<br />
            뉴브릿지는 우리 스스로 일의 공급자가 되어<br />
            일의 의미를 세우고,<br />
            그 과정 속에서<br />
            나를 재발견 할 수 있는 의미있는 장을<br />
            제공하고자 합니다.
          </p>
        </div>

        <div class="link">
          <button @click="openYoutube">
            <img src="@/assets/imgs/youtube.png" alt="" style="width: 30px" />
          </button>
          <button @click="openInstagram">
            <img src="@/assets/imgs/instagram.png" alt="" style="width: 30px" />
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AboutModal",
  props: ["modal", "close"],
  methods: {
    openYoutube() {
      this.$gtag.event("Youtube/about");
      window.open("https://youtu.be/HTzQjjSfQq4", "_blank");
    },
    openInstagram() {
      this.$gtag.event("Instagram/about");
      window.open("https://www.instagram.com/newbridge.studio/", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  left: 50%;
  top: 0;
  width: 100%;
  height: 100%;
  transform: translate(-50%, 0);
  z-index: 100000;
  background: linear-gradient(to top, #fff1d7, #fff);
  max-width: 480px;
  padding: 18px;
  text-align: left;
  padding-left: 33px;
  overflow-y: scroll;
  .xbtn {
    position: absolute;
    right: 18px;
    top: 18px;
    button {
      background: transparent;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      outline: 0;
      border: 0;
      cursor: pointer;
    }
  }
  h1 {
    padding-top: 74px;
  }
  h2 {
    padding-top: 24px;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.38;
  }

  p {
    padding-top: 31px;
    font-size: 14px;
    font-weight: 500;
    word-break: keep-all;
    white-space: pre-line;
  }
  .link {
    padding-top: 36px;
    button {
      background: transparent;
      margin-right: 18px;
      cursor: pointer;
      border: 0;
      outline: 0;
      display: inline-block;
    }
  }
}
.slide-up {
  transition: all 0.25s;
}
.slide-up-enter-active {
  transition: all 0.25s ease;
}
.slide-up-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-up-enter,
.slide-up-leave-active {
  /* top: 500px; */
  transform: translate(-50%, 100%);
}
</style>
